import React, { useState } from 'react';
import { Brand } from '../types/BookingTypes';
import { useNavigate } from 'react-router-dom';

interface BrandSelectorProps {
  brands: Brand[];
  selectedBrand: Brand | null;
}

const INITIAL_COUNT = 12;

const BrandSelector: React.FC<BrandSelectorProps> = ({ brands, selectedBrand }) => {
  const navigate = useNavigate();
  const [showAll, setShowAll] = useState(false);

  const visibleBrands = showAll ? brands : brands.slice(0, INITIAL_COUNT);

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-1 h-5 bg-minto-500 rounded-full" />
          <h3 className="text-base md:text-lg font-semibold text-gray-900">Select Your Brand</h3>
        </div>
      </div>
      <div className="bg-white rounded-lg border border-gray-100 shadow-sm p-3">
        <div className="grid grid-cols-4 gap-2">
          {visibleBrands.map((brand) => (
            <button
              key={brand.id}
              className={`flex flex-col items-center justify-center py-3 px-2 rounded-xl border transition-all duration-200 active:scale-95 ${
                selectedBrand?.id === brand.id
                  ? 'bg-minto-50 border-minto-400 shadow-md'
                  : 'bg-white border-gray-200 shadow-sm hover:shadow-md hover:border-minto-300'
              }`}
              onClick={() => navigate(`/brand/${brand.id}`)}
            >
              <div className="w-9 h-9 mb-1.5 flex items-center justify-center">
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className="w-full h-full object-contain"
                  loading="lazy"
                  decoding="async"
                  onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                />
              </div>
              <span className="font-medium text-gray-700 text-center leading-tight line-clamp-1 uppercase" style={{ fontSize: '0.7rem' }}>{brand.name}</span>
            </button>
          ))}
        </div>

        {/* View All */}
        {brands.length > INITIAL_COUNT && (
          <button
            onClick={() => setShowAll(!showAll)}
            className="w-full mt-2 pt-2 border-t border-gray-100 text-xs font-medium text-minto-600 hover:text-minto-700 flex items-center justify-center gap-1"
          >
            {showAll ? (
              <>Show Less <i className="fas fa-chevron-up text-[10px]"></i></>
            ) : (
              <>View All {brands.length} Brands <i className="fas fa-chevron-down text-[10px]"></i></>
            )}
          </button>
        )}
      </div>
    </div>
  );
};

export default BrandSelector;
